import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { SpaceButtonDirective } from '../../directives/space-button.directive';
import { SharedService } from '../../services/shared.service';
import { DataService } from '../../interfaces/DataService';
import { BeNeo4jService } from '../../services/be-neo4j.service';
import { CANCEL_AND_LOGOUT, CONNECT } from '../../shared/strings';
import { ConnectDatabaseFunction } from '../../types/ConnectDatabaseFunction';

@Component({
  selector: 'change-database',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatButtonModule,
    MatInputModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    MatCheckboxModule,
    SpaceButtonDirective
  ],
  templateUrl: './change-database.component.html',
  styleUrl: './change-database.component.scss'
})
export class ChangeDatabaseComponent implements OnInit{
  constructor(private sharedService: SharedService, private beNeo4jService: BeNeo4jService){}
  database = new FormGroup({
    data_service: new FormControl('', [Validators.required]),
  });

  CANCEL_AND_LOGOUT = CANCEL_AND_LOGOUT;
  CONNECT = CONNECT;

  
  data_services!: DataService[] | undefined;
  selectedOption: string | null = null;

  @Input() callback!: ConnectDatabaseFunction;
  @Input() onCancel!: Function;
  @Input() cancelText: string = "";

  ngOnInit(): void {
    this.data_services = this.sharedService.data_services;
  }

  onSubmit(){
    if (!this.database.valid) return;
    let selected = this.database.value.data_service;
    let data_service = this.data_services!.find((service: DataService) => selected === service.data_service_id);
    this.callback(data_service!);
  }

  isChecked(option: string): boolean {
    return this.selectedOption === option;
  }

  toggleSelection(option: string) {
    this.selectedOption = this.selectedOption === option ? null : option;
    this.database.controls['data_service'].setValue(this.selectedOption);
  }
}
